import React, { useEffect, useState } from "react";
import { Loader2, Image as ImageIcon } from "lucide-react";
import api from "../lib/api";

export default function ProofImage({ path }) {
  const [url, setUrl] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => {
    let obj;
    let active = true;
    api.get(`/files/${path}`, { responseType: "blob" })
      .then((res) => { if (active) { obj = URL.createObjectURL(res.data); setUrl(obj); } })
      .catch(() => setErr(true));
    return () => { active = false; if (obj) URL.revokeObjectURL(obj); };
  }, [path]);

  if (err) return <div className="text-xs text-slate-400 mt-2 flex items-center gap-1"><ImageIcon className="w-3.5 h-3.5" />Proof image unavailable</div>;
  if (!url) return <div className="mt-2 h-40 rounded-xl bg-slate-100 animate-pulse flex items-center justify-center"><Loader2 className="w-5 h-5 animate-spin text-slate-400" /></div>;
  return (
    <a href={url} target="_blank" rel="noreferrer" className="block mt-2" data-testid="proof-image-link">
      <img src={url} alt="Payment proof" className="w-full max-h-72 object-contain rounded-xl border border-slate-200 bg-white" />
      <div className="text-[10px] text-blue-600 mt-1">Tap image to view full size</div>
    </a>
  );
}
